import moment from 'moment';
import { ICalendarEntry } from '@gik/calendar/models/Calendar';
import { IAddToCalendarLinks } from '../components/AddToCalendarSelector';
import { BaseUserWithAvatar } from '@gik/core/models/gik/User';

export interface ICalendarClaim {
  id: string;
  entryId: string;
  pageTitle: string;
  recipientFullName?: string;
  pageThumbnail?: string;
  pageDescription?: string;
  pageNotes?: string;
  inkindRouteId?: string;
  pageUrl?: string;
  recipientAddress?: string;
  recipientCityAndState?: string;
  entry?: ICalendarEntry;
  supporter: BaseUserWithAvatar;
  description: string;
  note: string;
  serviceCategorySlug: string;
  serviceModule: string;
  serviceSlug: string;
  cartItems?: ICalendarClaimCartItem[];
  grubhubUrl?: string;
  carType?: string;
  addToCalendarLinks?: IAddToCalendarLinks;
}

export interface ICalendarClaimCartItem {
  imageUrl: string;
  thumbnailUrl: string;
  price: number;
  productId: number;
  productName: string;
  variationId: number;
}

export interface IUserProfileClaim extends ICalendarClaim {
  // TODO: review which fields are optional
  pageTitle: string;
  recipientFullName: string;
  pageThumbnail: string;
  pageDescription: string;
  pageNotes: string;
  inkindRouteId: string;
  pageUrl: string;
  recipientAddress: string;
  recipientCityAndState: string;
  entry: ICalendarEntry; // required
}

const getMomentDate = (date: string) => moment.utc(date);

export function getStartDateTime(claim: IUserProfileClaim) {
  return getMomentDate(claim.entry.startsAt);
}

export function getEndDateTime(claim: IUserProfileClaim) {
  return getMomentDate(claim.entry.endsAt);
}

// TODO: remove everything below (only used in user-profile)

export interface IGraphQLResult<T> {
  errors?: { message: string; code: number }[];
  data?: T;
}

export interface IGraphQLClaimData {
  // TODO: retrieving a claim should return a "Claim" model, which has all parameters (event id, etc)
  eventClaims: {
    id: number;
    userId: string;
    encodedClaimDetails: string;
  }[];
}
